/** @internal */
const QualitySymbol = {
	setAuto: Symbol(0),
	enableAuto: Symbol(0)
};
//#endregion
export { QualitySymbol };
